<template>
  <div :class="['frame-quotes', { 'frame-quotes--three': quotes.length > 2 }]">
    <sui-grid :columns="quotes.length" centered class="frame-quotes__columns">
      <sui-grid-row>
        <sui-grid-column v-for="(quote, index) in quotes" :key="index">
          <p class="frame-quotes__quote">
            {{ quote.text }}
          </p>
          <span>{{ quote.veichleName }} </span>
        </sui-grid-column>
      </sui-grid-row>
    </sui-grid>
  </div>
</template>

<script>
export default {
  name: "frame-quotes",
  props: {
    quotes: {
      type: Array,
      // required: true,
    },
  },

  methods: {},
};
</script>

<style lang="scss">
.frame-quotes {
  height: auto;
  width: 100%;
  position: relative;
  padding: 30px;
  display: flex;
  justify-content: center;

  &--three {
    .frame-quotes {
      &__quote {
        max-width: 80%;
      }
    }
  }

  &__quote {
    font-family: $saolitalic;
    font-size: 30px;
    max-width: 60%;
    margin: 0 auto;
    text-align: center;
  }

  span {
    display: block;
    position: relative;
    width: 100%;
    text-align: center;
    font-weight: 600;
    margin: 20px 0;
  }
}

@media (max-width: 1500px) {
  .frame-quotes {
    height: auto;
    width: 100%;
    position: relative;
    padding: 30px;
    display: flex;
    justify-content: center;

    &__quote {
      font-family: $saolitalic;
      font-size: 25px;
      max-width: 50%;
      margin: 0 auto;
      text-align: center;
    }
  }
}

@media (max-width: 1200px) {
  .frame-quotes {
    height: auto;
    width: 100%;
    position: relative;
    padding: 30px;
    display: flex;
    justify-content: center;

    &__quote {
      font-family: $saolitalic;
      font-size: 22px;
      max-width: 50%;
      margin: 0 auto;
      text-align: center;
    }
  }
}

@media (max-width: 1200px) {
  .frame-quotes {
    height: auto;
    width: 100%;
    position: relative;
    padding: 20px;
    display: flex;
    justify-content: center;

    .row {
      padding: 0 !important;

      .column {
        padding: 0 !important;
        width: 100% !important;
        margin-bottom: 30px !important;
      }
    }

    &__quote {
      font-family: $saolitalic;
      font-size: 22px;
      max-width: 50%;
      margin: 0 auto;
      text-align: center;
    }
  }
}

@media (max-width: 1000px) {
  .frame-quotes {
    &__quote {
      max-width: 85%;
    }
  }
}
</style>
